import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { toggleNone } from "../helpers/hiddenVisible"

export const Table2Query = graphql`
  query Table2Query {
    a_royaleclash {
      card_stats(
        order_by: {fullName: asc}
      ) {
        id
        fullName
        unit_statistics_table
        unit_attributes_table
      }
    }
  }
`

const ToggleHideAllColumns = ({ data }) => {
  // once we have columns lets hide them all to start
  const cardStats = data.a_royaleclash.card_stats
  const target = JSON.parse(cardStats[0].unit_statistics_table)
  for (let k in target) toggleNone(k)
  // const target2 = JSON.parse(cardStats[0].unit_attributes_table)
  // for (let k in target2) toggleNone(k)
}

const StatHeaderKeys = ({ data }) => {
  const cardStats = data.a_royaleclash.card_stats
  const target = JSON.parse(cardStats[0].unit_statistics_table)
  // console.log(target)
  let keys = []
  for (let k in target) keys.push(k)
  return keys
}

const TableHeader = ({ data }) => {
  const cardStats = data.a_royaleclash.card_stats
  const target = JSON.parse(cardStats[0].unit_statistics_table)
  // console.log(target)
  let tableHeaderItem = []
  // Temporary stop gap until sorting by column header implemented
  // Then will want to place name as first column, level second column
  tableHeaderItem.push(<th key={'first'} className=""></th>)
  tableHeaderItem.push(<th key={'second'} className="">Name</th>)
  tableHeaderItem.push(<th key={'third'} className="">Level</th>)
  tableHeaderItem.push(<th key={'rarity'} className="">rarity</th>) // maybe
  for (let k in target) tableHeaderItem.push(<th key={k.toString()} className="headerTitle">{k}</th>)

  // className={k}
  // console.log(tableHeaderItem)
  const [getName, setName] = React.useState('')
  const handleNameChange = (e) => {
    setName(e.target.value)
    toggleNone(e.target.value)
  }
  const ColumnSelector = () => {
    const rangeWeCareAbout = tableHeaderItem.slice(3, -1)
    return (
      <select value={getName} onChange={handleNameChange}>
        {rangeWeCareAbout.map((x, y) => <option key={x.key}>{x.key}</option>)}
      </select >
    )
  }

  return (
    <>
      <div style={{ position: 'absolute', top: 65, justifyContent: 'space between' }}>
        <ColumnSelector />
        <button onClick={() => ToggleHideAllColumns({ data })}>Toggle All Columns</button>
      </div>
      <thead>
        <tr></tr>
        <tr className="allHeaderTitles">{tableHeaderItem}</tr>
      </thead >
    </>
  )
}

const RowCreator = ({ data, index }) => {
  const cards = data.a_royaleclash.card_stats
  const unitStatisticsTable = cards[index].unit_statistics_table
  const unitAttributesTable = cards[index].unit_attributes_table
  const fullName = cards[index].fullName
  // const rarity = cards[index].unit_attributes_table // maybe
  const jsonData = JSON.parse(unitStatisticsTable)
  const jsonData2 = JSON.parse(unitAttributesTable)
  const levels = jsonData["Level"]
  const rarity = jsonData2["Rarity"]
  // const rarityNumber = []
  // console.log(rarity) // worked
  // not working
  // rarity.map((i) => {
  //   if (i === 'Common') {
  //     rarityNumber.push(1)
  //   }
  //   if (i === 'Rare') {
  //     rarityNumber.push(2)
  //   }
  //   if (i === 'Epic') {
  //     rarityNumber.push(3)
  //   }
  //   if (i === 'Legendary') {
  //     rarityNumber.push(4)
  //   }
  // })
  // _____________________________________________________________________
  // this worked for first level for all cards and all levels for common
  // const [getLevel, setLevel] = React.useState(0)

  // const handleLevelChange = (e) => {
  //   const computeLevel = e.target.value - 1
  //   setLevel(computeLevel)
  // }

  // const LevelSelector = (e) => (
  //   <select value={getLevel + 1} onChange={handleLevelChange}>
  //     {levels.map((x, y) => <option key={y}>{x}</option>)}
  //   </select >
  // )
  // _____________________________________________________________________
  // NEW PLAN: grab rarity, convert to number then useState
  // first grab rarity
  // const Rarity2 = () => {
  //   rarityNumber
  // }

  // common       1-13  13 options
  // rare         3-13  11 options
  // epic         6-13   8 options
  // legendary    9-13   5 options

  let rarityLevel = 1
  if (rarity === 'Common') {
    //   rarityLevel = 0
    // rarityLevel = 0
    rarityLevel = 1
  }
  if (rarity === 'Rare') {
    //   rarityLevel = 2 // level 3 - 11 work now but level 12 - 13 don't
    // rarityLevel = 2
    rarityLevel = 3
  }
  if (rarity === 'Epic') {
    //   rarityLevel = 5  // level 6 - 8 work but level 9 - 13 don't
    // rarityLevel = 3
    rarityLevel = 6
  }
  if (rarity === 'Legendary') {
    // rarityLevel = 7 // 7
    // rarityLevel = 5
    rarityLevel = 9
  }
  const Rarity = () => rarity // worked great for rarity string
  const Rarity2 = () => rarityLevel // worked great for rarity string

  // archers       damage-a level  1 should be 129
  // archers       damage-a level 13 should be 367

  // battle healer damage-a level  3 should be 70
  // battle healer damage-a level 13 should be 179

  // archers       damage-a level  1 should be 129
  // archers       damage-a level 13 should be 367

  // baby dragon   damage-a level  1 should be 129
  // baby dragon   damage-a level 13 should be 367


  // const [getLevel, setLevel] = React.useState(0) // 0 index start at beginning
  // const [getLevel, setLevel] = React.useState(1) // starts level dropdown at +1 not ideal, so do not
  const [getLevel, setLevel] = React.useState(rarityLevel) // start at correct level for each
  const handleLevelChange = (e) => {
    // const computeLevel = e.target.value - 1 // -1 to get to 0 index // req
    // const computeLevel = e.target.value
    // console.log(e.target.value) // prefer this was exactly what it is now
    setLevel(e.target.value) // prefer this was exactly what it is now
    console.log(getLevel)
    // setLevel(computeLevel)
    // console.log(computeLevel)
    // console.log(getLevel)
  }

  const LevelSelector = () => {
    // console.log(getLevel + 1)
    // console.log(getLevel)
    return (
      // plus 1 req for selector to register the level you selected aka without +1 you cant select level 13
      // <select value={getLevel + 1} onChange={handleLevelChange}> // I believe this was the og
      // <select value={getLevel} onChange={handleLevelChange}>
      <select value={getLevel + 1} onChange={handleLevelChange}>
        {/* {levels.map((x, y) => <option key={y}>{x}</option>)} */}
        {levels.map((x, y) => <option key={y} value={y}>{x}</option>)}
      </select >
    )
  }

  const keys = StatHeaderKeys({ data })

  return (
    <tr className="roww">
      <td></td>
      <td className="stickyLeft">{fullName}</td>
      <td><LevelSelector /></td>
      <td><Rarity /></td>
      {/* <td><Rarity2 /></td> */}
      {keys.map((key, i) => {
        // console.log(jsonData[key][getLevel - 1])
        // console.log(getLevel) // all starting at level 1
        // console.log(i) // 0 to 37 multiple times
        // console.log(key) // Active-healing-per-pulse-A and so on
        // console.log(jsonData[key]) // lots of empty arrays and a few full ones
        // console.log(jsonData[key][i]) // promising, just a bunch of data numbers
        // console.log(jsonData[key][getLevel]) // promising, just a bunch of data numbers
        return (
          // og original, only accurate for common cards
          // <td className={key}>
          //   {jsonData[key][getLevel] ? jsonData[key][getLevel] : null}
          // </td>

          // suspect this is what needs changing, sort of worked but not as rarity and level went up
          // <td className={key}>
          //   {jsonData[key][getLevel] ? jsonData[key][getLevel - rarityLevel] : null}
          // </td>

          //
          <td className={key}>
            {/* {jsonData[key][getLevel - rarityLevel] ? jsonData[key][getLevel - rarityLevel] : null} */}
            {/* {jsonData[key][getLevel] ? jsonData[key][getLevel] : null} */}
            {/* {jsonData[key][getLevel - 1] ? jsonData[key][getLevel - 1] : null} */}
            {jsonData[key][getLevel] ? jsonData[key][getLevel] : null}
          </td>
        )
      }
      )}
    </tr>

  )
}

const SearchByFirstColumn = () => {
  function search_table() {
    let input, filter, table, tr, td
    input = document.getElementById("SearchByFirstColumn")
    filter = input.value.toUpperCase()
    table = document.getElementById("myTable")
    tr = table.getElementsByTagName("tr")
    // Loop through all table rows, and hide those who don't match the search query
    for (let i = 0; i < tr.length; i++) {
      // td = tr[i].getElementsByTagName("td") // search all rows, sadly includes category row so no......
      td = tr[i].getElementsByClassName("stickyLeft") // first row // all we really need search by one row: faster
      for (let j = 0; j < td.length; j++) {
        let tabularData = td[j]
        if (tabularData) {
          if (tabularData.innerHTML.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = ""
            break
          } else {
            tr[i].style.display = "none"
          }
        }
      }
    }
  }

  return (
    <input
      placeholder="Search by Y name"
      type="text" id="SearchByFirstColumn" onChange={() => search_table()}
      style={{ fontSize: '11px', paddingLeft: '10px', color: 'white', background: 'black' }}
    />
  )
}

const SearchByHeaderName = () => {
  function search_table() {
    let input, filter, i, j, txtValue, allHeaderTitles, th, td, underHeader, tempClassName
    input = document.getElementById("SearchByHeaderName")
    filter = input.value.toUpperCase()
    allHeaderTitles = document.getElementsByClassName("headerTitle")
    td = document.getElementsByTagName("td")
    for (i = 0; i < allHeaderTitles.length; i++) {
      th = allHeaderTitles[i]
      txtValue = th.textContent || th.innerText
      tempClassName = th.innerHTML
      underHeader = document.getElementsByClassName(tempClassName)
      for (j = 0; j < underHeader.length; j++) {
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          underHeader[j].style.display = ""
          th.style.display = ""
        } else {
          underHeader[j].style.display = "none"
          th.style.display = "none"
        }
      }
    }
  }

  return (
    <input
      placeholder="Search by X name"
      type="text" id="SearchByHeaderName" onChange={() => search_table()}
      style={{ fontSize: '11px', paddingLeft: '10px', color: 'white', background: 'black' }}
    />
  )
}
const Tables2 = ({ data }) => {
  return (
    <Layout>
      <SEO title="Tables" />
      <table className="table" id="functionality">
        <tbody className="flex roww fixed">
          <tr className="flex1">
            <td style={{ visibility: 'hidden' }}></td>
            <td style={{ visibility: 'hidden' }}></td>
          </tr>
          <tr className="flex2">
            <SearchByFirstColumn />
          </tr>
          <tr className="flex2">
            <SearchByHeaderName />
          </tr>
        </tbody>
      </table>
      <table className="table" id="myTable">
        <td></td>
        <TableHeader data={data} />
        <tbody key={data.id}>
          {data.a_royaleclash.card_stats.map((card, i) => <RowCreator data={data} index={i} key={card.id} />)}
        </tbody>
      </table>
    </Layout >
  )
}

export default Tables2
